

import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import T6 from '../../components/ExcerciseTypes/TypeIn/T6';
import D1 from '../../components/ExcerciseTypes/Design/TypeIn';

const json = {

  1: {
    unit: 'Unit 12',
    id: 'SB4-U12-P86-E1',
    audio: 'img/FriendsPlus/Page86/Audio/audio-e1-p86.mp3',
    video: '',
    component: UI,
    recorder: true,
    titleImage: '',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page86/E1/1.jpg' },
        { url: 'img/FriendsPlus/Page86/E1/2.jpg', audioUrl: 'img/FriendsPlus/Page86/Audio/tieude-e1-p86.mp3' },
        { url: 'img/FriendsPlus/Page86/E1/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page86/E1/4.jpg' },
        { url: 'img/FriendsPlus/Page86/E1/5.jpg', audioUrl: 'img/FriendsPlus/Page86/Audio/hinh1-e1-p86.mp3' },
        { url: 'img/FriendsPlus/Page86/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page86/E1/7.jpg', audioUrl: 'img/FriendsPlus/Page86/Audio/hinh2-e1-p86.mp3' },
        { url: 'img/FriendsPlus/Page86/E1/8.jpg' },
        { url: 'img/FriendsPlus/Page86/E1/9.jpg', audioUrl: 'img/FriendsPlus/Page86/Audio/hinh3-e1-p86.mp3' },
        { url: 'img/FriendsPlus/Page86/E1/10.jpg' },
        { url: 'img/FriendsPlus/Page86/E1/11.jpg', audioUrl: 'img/FriendsPlus/Page86/Audio/hinh4-e1-p86.mp3' },
        { url: 'img/FriendsPlus/Page86/E1/12.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page86/E1/13.jpg' },
        { url: 'img/FriendsPlus/Page86/E1/14.jpg', audioUrl: 'img/FriendsPlus/Page86/Audio/hinh5-e1-p86.mp3' },
        { url: 'img/FriendsPlus/Page86/E1/15.jpg' },
        { url: 'img/FriendsPlus/Page86/E1/16.jpg', audioUrl: 'img/FriendsPlus/Page86/Audio/hinh6-e1-p86.mp3' },
        { url: 'img/FriendsPlus/Page86/E1/17.jpg' },
        { url: 'img/FriendsPlus/Page86/E1/18.jpg', audioUrl: 'img/FriendsPlus/Page86/Audio/hinh7-e1-p86.mp3' },
        { url: 'img/FriendsPlus/Page86/E1/19.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page86/E1/3.jpg' },
      ],

    ]
  },


  2: {
    unit: 'Unit 12',
    id: 'SB4-U12-P86-E1',
    audio: 'img/FriendsPlus/Page86/Audio/audio-e2-p86.mp3',
    video: 'img/FriendsPlus/Page86/Videos/e2.86.mp4',
    component: UI,
    recorder: true,
    titleImage: '',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page86/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page86/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page86/Audio/tieude-e2-p86.mp3' },
        { url: 'img/FriendsPlus/Page86/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page86/E2/4.jpg', audioUrl: 'img/FriendsPlus/Page86/Audio/hinh1-e2-p86.mp3' },
        { url: 'img/FriendsPlus/Page86/E2/5.jpg', audioUrl: 'img/FriendsPlus/Page86/Audio/hinh2-e2-p86.mp3' },


      ],
      [
        { url: 'img/FriendsPlus/Page86/E2/6.jpg', audioUrl: 'img/FriendsPlus/Page86/Audio/hinh3-e2-p86.mp3' },
        { url: 'img/FriendsPlus/Page86/E2/7.jpg', audioUrl: 'img/FriendsPlus/Page86/Audio/hinh4-e2-p86.mp3' },
      ],
    ]
  },




}
export default json;
